import {RootState} from '../reducers';
import * as NDWI from '../reducers/ndwi';

export const ndwiDataSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiDataSelector(state.ndwi);
export const ndwiGetSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiGetSelector(state.ndwi);
export const ndwiFarmIdSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiFarmIdSelector(state.ndwi);
export const ndwiActiveFarmSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiActiveFarmSelector(state.ndwi);
export const ndwiSelectedDateSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiSelectedDateSelector(state.ndwi);
export const ndwiImageTypeSelector = (state: Pick<RootState, 'ndwi'>) => NDWI.ndwiImageTypeSelector(state.ndwi);
